import React from 'react';
import { ExpandOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

import { ResponsiveBar } from '@nivo/bar';

import './../vignette.style.scss';
import './histogram.style.scss';
import { theme } from '../globalTheme';
import { percentReduce } from '../vignette.utils';

// import ModalHistogram from './ModalHistogram';

interface HistogramVignetteComponentProps {
  data: [];
  keys: string[];
  isZoom?: boolean;
  isCustomProject?: boolean;
  indexBy?: string;
  isPdf?: boolean;
}
const HistogramVignetteComponent = ({
  data,
  keys,
  isZoom,
  isCustomProject,
  indexBy = 'name',
  isPdf,
  ...rest
}: HistogramVignetteComponentProps) => {
  // const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <div className="responsive-bar vignette" style={{ height: 400 }}>
      {/* <ModalHistogram isZoom {...{ data, keys, isModalOpen, setIsModalOpen }} /> */}
      <div className="responsive-bar__wrapper">
        <ResponsiveBar
          {...rest}
          enableLabel={false}
          theme={theme}
          data={data}
          keys={keys}
          indexBy={indexBy}
          valueScale={{ type: 'linear' }}
          padding={0.6}
          margin={{
            top: 30,
            bottom: isCustomProject ? 40 : 100,
            right: 50,
            left: 65,
          }}
          colors={({ id, data }) => data[`${id}Color`]}
          axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            format: (value) => {
              return value.toString().length > 3 ? (
                <tspan>
                  {value.toString().substring(0, 3) + '...'}
                  <title>{value}</title>
                </tspan>
              ) : (
                value
              );
            },
            legend: 'Impact environnemental (kg eq. CO2)',
            legendPosition: 'middle',
            legendOffset: -60,
          }}
          axisRight={{
            format: (value) =>
              `${Math.round((value * 100) / percentReduce(data))}%`,
          }}
          axisBottom={{
            tickRotation: !isCustomProject ? -45 : 0,
            format: (value) => {
              if (isCustomProject) {
                return (
                  <tspan>
                    <>
                      <tspan x="0" dy="-0.4em">
                        {value === 'Autres' ? '[...]' : value.split(' ')[0]}
                      </tspan>
                    </>
                    <title>{value}</title>
                  </tspan>
                );
              }

              return value.length > 18 ? (
                <tspan>
                  {value.substring(0, 18) + '...'}
                  <title>{value}</title>
                </tspan>
              ) : (
                value
              );
            },
          }}
        />
      </div>
      {!isZoom && !isPdf && (
        <ExpandOutlined
          className="responsive-bar__expand-button"
          onClick={() => null}
        />
      )}
    </div>
  );
};

export default HistogramVignetteComponent;
